import React from 'react';

import PropTypes from 'prop-types';
import { Box, TextInput, Button, Divider, StackView } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import ConfirmationBox from '../../../design/shared/ConfirmationBox';

const SendContractToModal = ({
  contractRecipient,
  setRecipient,
  setContractRecipient,
  setIsModalOpen
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      emailDetail: {
        contractAddress,
        contractAddressDetail,
        CCEmailAddress,
        CCEmailAddressDetail
      }
    },
    assigneeSRTModal: { addButton }
  } = localizedStrings;

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <ConfirmationBox header="Add Recipients" open setOpen={closeModal}>
      <div style={{ marginTop: '2rem' }}>
        <StackView space={3}>
          <TextInput
            label={contractAddress}
            hint={contractAddressDetail}
            value={contractRecipient.to}
            onChange={(value) =>
              setContractRecipient({ ...contractRecipient, to: value })
            }
          />
          <TextInput
            label={CCEmailAddress}
            hint={CCEmailAddressDetail}
            value={contractRecipient.cc}
            onChange={(value) =>
              setContractRecipient({ ...contractRecipient, cc: value })
            }
          />
        </StackView>
        <Divider space={2} variant={{ inverse: true }} />
        <Button onPress={setRecipient}>{addButton}</Button>
      </div>
    </ConfirmationBox>
  );
};

SendContractToModal.propTypes = {
  setIsModalOpen: PropTypes.func.isRequired,
  setRecipient: PropTypes.func.isRequired,
  setContractRecipient: PropTypes.func.isRequired,
  contractRecipient: PropTypes.shape({
    to: PropTypes.string,
    cc: PropTypes.string
  }).isRequired
};

export default SendContractToModal;
